import { SparklesIcon } from '@heroicons/react/24/solid';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const DayZeroAIFeaturesSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHanlder = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label
        icon={SparklesIcon}
        id="day-zero-ai-features-label"
        htmlFor="day-zero-ai-features"
      >
        Day zero AI features
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="day-zero-ai-features"
          aria-labelledby="day-zero-ai-features-label"
          isSelected={organization.is_day_zero_ai_features_enabled}
          isPending={isLoading}
          onChange={async () => {
            updateOrgHanlder(
              updateOrganization({
                organization_id: orgId,
                updatePayload: {
                  is_day_zero_ai_features_enabled: !organization.is_day_zero_ai_features_enabled,
                },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
